import { render, staticRenderFns } from "./WebhookHistorical.vue?vue&type=template&id=673834e3&scoped=true"
import script from "./WebhookHistorical.vue?vue&type=script&lang=js"
export * from "./WebhookHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673834e3",
  null
  
)

export default component.exports